import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Title = styled.h1`
  display: flex;
  font-weight: bold;
`;

function TitlePage({ title }) {
  return <Title>{title}</Title>;
}

TitlePage.propTypes = {
  title: PropTypes.string.isRequired,
};

TitlePage.defaultProps = {};

export default TitlePage;
